import React, { useState } from 'react';
import styles from './HATVLegs.module.scss';
import { useAppSelector } from '../../../redux/hooks';
import dropdownArrowLight from '../../../../src/assets/images/LightTheme/down_arrow_light.svg';
import dropdownArrowDark from '../../../../src/assets/images/DarkTheme/down_arrow_dark.svg';
import LegViolationTable from '../LegViolationTable/LegViolation';
import Icon from '../../common/Icon/Icon';
import { useTranslation } from 'react-i18next';
import PerformanceTable from '../PerformanceTable/PerformanceTable';
import { useGetHATVQmonthLegsAPIQuery } from '../../../redux/services/hatvQmonthDetailsAPI';
import { useABOProfileNavigation, useProfileParams } from '../../../utils/common';
import ErrorInPageScreen from '../../common/ErrorInPageScreen/ErrorInPageScreen';
import { getCountryNameFromCode } from '../../../utils/awardIconMapping';
interface HATVLegsProps {
  selectedYearMonth: string;
}
const HATVLegs: React.FC<HATVLegsProps> = ({ selectedYearMonth }) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const { t } = useTranslation();
  const [isContentVisible, setIsContentVisible] = useState<{
    [key: number]: Boolean;
  }>({});
  const { affiliateCode, aboNumber } = useProfileParams();
  const dropdownArrow = currentTheme === 'light' ? dropdownArrowLight : dropdownArrowDark;

  const { data } = useGetHATVQmonthLegsAPIQuery(
    {
      closingMonth: selectedYearMonth,
      affiliateCode,
      aboNumber,
    },
    {
      skip: !selectedYearMonth,
    }
  );

  const legsList = data?.body?.legs ?? [];
  const [activeTab, setActiveTab] = useState<{
    [key: number]: 'leg_violation' | 'leg_data';
  }>({
    0: 'leg_violation',
    1: 'leg_violation',
    2: 'leg_violation',
    3: 'leg_violation',
    4: 'leg_violation',
  });
  const handleDropdownClick = (index: number) => {
    setIsContentVisible((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handleABOInfoClick = useABOProfileNavigation();
  return (
    <div className={`hatv_leg_wrapper ${styles.hatv_leg_wrapper}`}>
      <div className={styles.hatve_leg_header_wrapper}>
        <div className={styles.hatv_leg_header}>{t('leg_details')}</div>
      </div>

      {legsList.length ? (
        legsList.map((legData, index) => (
          <div key={legData.aboNumber}>
            <div
              className={styles.leg_title_wraper}
              style={{
                borderBottom: !isContentVisible[index]
                  ? `1px solid ${currentTheme === 'light' ? '#E4E4E4' : '#282828'}`
                  : '',
                marginBottom: !isContentVisible[index] ? '24px' : '',
              }}
            >
              <div className={styles.content_inner_label} data-testid="content_inner_label">
                <div className={styles.main_label}>
                  <span
                    className={legData?.localName ? `abo_name ${styles.abo_name}` : styles.no_abo}
                    onClick={
                      legData?.localName
                        ? () => handleABOInfoClick(legData.aboNumber, legData.affiliateCode)
                        : undefined
                    }
                  >
                    {legData?.localName || '--'}
                  </span>

                  <span className={`additional_info ${styles.additional_info}`}>
                    {legData.aboNumber} |{' '}
                    {legData?.legTypeName === 'In Market'
                      ? legData.legTypeName
                      : getCountryNameFromCode(legData?.marketCountryCode, t)}{' '}
                    | {t('Account_table_headers.Q_Months')}: {legData.qMonth}
                  </span>
                </div>
              </div>
              <img
                src={dropdownArrow}
                alt="Dropdown Arrow"
                className={`dropdown_icon ${styles.dropdown_icon} ${isContentVisible[index] ? styles.rotate : ''}`}
                onClick={() => handleDropdownClick(index)}
                style={{
                  cursor: 'pointer',
                }}
              />
            </div>
            {isContentVisible[index] && (
              <div className={styles.leg_inner_wrapper}>
                <div className={styles.leg_award_wrapper}>
                  <span className={styles.current_award}>
                    <span className={`award_lable ${styles.award_lable}`}>
                      {t('currentAward')}:
                    </span>{' '}
                    <span className={`award_value ${styles.award_value}`}>
                      {legData?.currentAward?.awardName ?? '-'}
                    </span>
                  </span>
                  <div className={`divider ${styles.divider}`}>|</div>
                  <span className={styles.highest_award}>
                    <span className={`award_lable ${styles.award_lable}`}>
                      {t('highest_award')}:
                    </span>{' '}
                    <span className={`award_value ${styles.award_value}`}>
                      {legData?.highestAward?.awardName ?? '-'}
                    </span>
                  </span>
                </div>

                <div className={styles.leg_tab_wrapper}>
                  <div className={`tabs ${styles.tabs}`}>
                    <div
                      className={`tab ${styles.tab} ${activeTab[index] === 'leg_violation' ? styles.active : ''}`}
                      onClick={() =>
                        setActiveTab((prev) => ({
                          ...prev,
                          [index]: 'leg_violation',
                        }))
                      }
                    >
                      {t('leg_violation')}
                    </div>
                    <div
                      className={`${styles.tab} ${activeTab[index] === 'leg_data' ? styles.active : ''}`}
                      onClick={() =>
                        setActiveTab((prev) => ({
                          ...prev,
                          [index]: 'leg_data',
                        }))
                      }
                    >
                      {t('leg_data')}
                    </div>
                  </div>
                </div>
                <div className={`tab_content ${styles.tab_content}`}>
                  {activeTab[index] === 'leg_violation' ? (
                    <LegViolationTable
                      closingMonth={selectedYearMonth}
                      affiliateCode={legData.affiliateCode}
                      aboNumber={+legData.aboNumber}
                    />
                  ) : (
                    <PerformanceTable
                      closingMonth={selectedYearMonth}
                      affiliateCode={legData.affiliateCode}
                      aboNumber={+legData.aboNumber}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <div>{t('no_legs_found')}</div>
      )}
    </div>
  );
};

export default HATVLegs;
